var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',[_c('p',{staticClass:"credits"},[_c('br'),_c('br'),(_vm.skin.header_desktop.logo != '')?_c('img',{staticStyle:{"max-width":"270px","max-height":"240px"},attrs:{"src":_vm.skin.header_desktop.logo,"width":_vm.skin.header_desktop.logo_width,"alt":""},on:{"click":_vm.render_home}}):_vm._e(),_c('br'),_c('br')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }